module.exports = __webpack_public_path__ + "img/Tajikistan.f179e0fc.svg";